<!-- SIDEBAR CONTENT -->
<div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{y:'50px'}}">

    <div class="p-24">
        <button mat-raised-button
                class="mat-accent add-todo-button w-100-p"
                (click)="addEvent()"
                aria-label="New reservation">
            {{'New reservation'|translate}}
        </button>
    </div>

    <div class="nav material2">
        <div class="nav-item">
            <a class="nav-link" matRipple [routerLink]="'/calendar'" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">calendar_today</mat-icon>
                <span>{{'Today'|translate}}</span>
            </a>
        </div>
        <div class="nav-item">
            <a class="nav-link" matRipple [routerLink]="'/calendar/tomorrow'" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">calendar_today</mat-icon>
                <span>{{'Tomorrow'|translate}}</span>
            </a>
        </div>
        <div class="nav-item">
            <a class="nav-link" matRipple [routerLink]="'/calendar/7-days'" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">calendar_today</mat-icon>
                <span>{{'7 days'|translate}}</span>
            </a>
        </div>
        <div class="nav-item">
            <a class="nav-link" matRipple [routerLink]="'/calendar/month'" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">calendar_today</mat-icon>
                <span>{{'Month'|translate}}</span>
            </a>
        </div>
        <div class="nav-item">
            <a class="nav-link" matRipple [routerLink]="'/calendar/year'" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">calendar_today</mat-icon>
                <span>{{'Year'|translate}}</span>
            </a>
        </div>

        <div class="nav-item">
            <ul>
                <li *ngFor="let user of users">
                    <input type="checkbox" (change)="checkUser($event)" value="{{user.id}}"> {{ user.name }}
                </li>
            </ul>
        </div>
    </div>

</div>
<!-- / SIDEBAR CONTENT -->
